module.exports = __webpack_public_path__ + "static/media/icn_back_dark.e056c44b.svg";